/* tslint:disable */
import {Injectable} from '@angular/core';
import {BaseRestService} from './base-rest.service';
import {HttpClient} from '@angular/common/http';
import {AppSettingsService} from './app-settings.service';
import {Observable} from 'rxjs';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {SharedModule} from '../shared.module';

@Injectable({providedIn: SharedModule})
export class LicencesService extends BaseRestService {

  constructor(http: HttpClient, appSettingsService: AppSettingsService) {
    super(http, appSettingsService);
  }

  protected get className(): string {
    return 'LicencesService';
  }

  protected get isAnonymous(): boolean {
    return false;
  }

  getList(): Observable<SendBackResult<ArrayResponse<any>>> {
    return this.get<ArrayResponse<any>>(`/LicenseProviders`);
  }

}
